import { Alert, Col, Row, Spin } from "antd";
import { useSemaforoFase2 } from "../../../hooks/useAsistenciasSemaforo";
import { PorCerrarServicio } from "../semaforo/porCerrarServicio/PorCerrarServicio";
import { PorContactarUsuario } from "../semaforo/porContactarUsuario/PorContactarUsuario";

export const SemaforoFase2 = () => {
  const { asistencias, loading, error } = useSemaforoFase2();

  if (loading) return <Spin />;
  if (error) return <Alert type="error" message="No se pudo consultar el semáforo fase 2" />;

  return (
    <Row className="semaforo-general" gutter={[8, 8]}>
      <Col xs={24} md={12}><PorContactarUsuario asistenciasSemaforo={asistencias} /></Col>
      <Col xs={24} md={12}><PorCerrarServicio asistenciasSemaforo={asistencias} /></Col>
    </Row>
  );
};
